import Activity from './activity'
import GlobalSlide from './global_slide'
import GlobalSlideActivityResult from './global_slide_activity_result'
import ResourceCard from './resource_card'
import LearningPlan from './learning_plan'
import User from './user'

import DiscussionTopic from './discussion_topic'
import DiscussionComment from './discussion_comment'

import ActivityV1Article from './activity/v1/article'
import ActivityV1Audio from './activity/v1/audio'
import ActivityV1BasicContent from './activity/v1/basic_content'
import ActivityV1Discussion from './activity/v1/discussion'
import ActivityV1Fullscreen from './activity/v1/fullscreen'
import ActivityV1IntentionSetter from './activity/v1/intention_setter'
import ActivityV1PairedComparison from './activity/v1/paired_comparison'
import ActivityV1Poll from './activity/v1/poll'
import ActivityV1Quiz from './activity/v1/quiz'
import ActivityV1Resource from './activity/v1/resource'
import ActivityV1SelfAssessment from './activity/v1/self_assessment'
import ActivityV2SelfAssessment from './activity/v2/self_assessment'
import ActivityV1Video from './activity/v1/video'
import ActivityV1VideoWithInstruction from './activity/v1/video_with_instruction'

export default {
  load: function(apiClient) {
    apiClient.define('activity', Activity)
    apiClient.define('global_slide', GlobalSlide)
    apiClient.define('global_slide_activity_result', GlobalSlideActivityResult)
    apiClient.define('activity_v1_article', ActivityV1Article)
    apiClient.define('activity_v1_audio', ActivityV1Audio)
    apiClient.define('activity_v1_basic_content', ActivityV1BasicContent)
    apiClient.define('activity_v1_discussion', ActivityV1Discussion)
    apiClient.define('activity_v1_fullscreen', ActivityV1Fullscreen)
    apiClient.define('activity_v1_intention_setter', ActivityV1IntentionSetter)
    apiClient.define('activity_v1_paired_comparison', ActivityV1PairedComparison)
    apiClient.define('activity_v1_poll', ActivityV1Poll)
    apiClient.define('activity_v1_quizz', ActivityV1Quiz) // The double 'zz' is a devour pluralization limitation
    apiClient.define('activity_v1_resource', ActivityV1Resource)
    apiClient.define('activity_v1_self_assessment', ActivityV1SelfAssessment)
    apiClient.define('activity_v2_self_assessment', ActivityV2SelfAssessment)
    apiClient.define('activity_v1_video', ActivityV1Video)
    apiClient.define('activity_v1_video_with_instruction', ActivityV1VideoWithInstruction)
    apiClient.define('learning_plan', LearningPlan)
    apiClient.define('resource_card', ResourceCard)
    apiClient.define('discussion_topic', DiscussionTopic)
    apiClient.define('discussion_comment', DiscussionComment)
    apiClient.define('user', User, { collectionPath: 'user' })
  }
}
